import React from 'react';

import {
  BACK,
  MASTER_READING_PAGES,
  MATCH_TICKETS,
  MATCH_TICKETS_MACHINE_FIELDS,
} from './constants';
import { Checkbox, TableCell } from '@material-ui/core';
import './MasterReading.css';
import { Layout } from '../../global/Table/TablePageHelpers/LayoutObject';
import TablePage from '../../global/Table/TablePage';
import { GetApp } from '@material-ui/icons';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import { DEFAULT_PDF_ZOOM } from '../../global/constants';
import Utils from '../../Utils/Utils';
import ZoomOutIcon from '@material-ui/icons/ZoomOut';
import ZoomInIcon from '@material-ui/icons/ZoomIn';
import RenderPurchaseOrderPDFPreview from '../../transaction/RenderPurchaseOrderPDFPreview';
import VisibilityIcon from '@mui/icons-material/Visibility';
import {
  getMatchPointPDFPreview,
  resetMatchPointPdfPreviewData,
} from '../../../redux/actions/settings';

import { matchPointPDFpreviewReadySelector } from '../../../redux/selectors/ticketOut';
import withShipment from '../../../withShipment';
import CustomToolbar from '../../global/CustomToolbar';
import PrintIcon from '@mui/icons-material/Print';
import EmployeeTicketsTable from './EmployeeTicketsTable';
import { userInfoSelector } from '../../../redux/selectors/auth';

class MatchTicketsTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filteredEmployeeTickets: [],
      showEmployeeList: false,
      selectedRowIndex: null,
      isMobile: window.matchMedia('(max-width: 800px)').matches,
      //report
      scale: DEFAULT_PDF_ZOOM,
      showPdfViewer: false,
      pdfLoadSuccess: true,
      pdfData: [],
      showEditEmployeeTickets: false,
    };
  }

  componentDidMount() {
    this.props.listMatchTickets(
      this.props.selectedSessionId,
      this.props.userInfo.selectedLocationId
    );
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      !this.arrayEquals(prevProps.PDFpreviewReady, this.props.PDFpreviewReady)
    ) {
      this.setState({
        pdfData: this.props.PDFpreviewReady,
      });
    }
  }

  arrayEquals(arr1, arr2) {
    if (!arr1 || !arr2) return false;
    if (arr1.length !== arr2.length) return false;
    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i] !== arr2[i]) return false;
    }
    return true;
  }

  getTableHeaders = () => {
    let headers = [];
    headers.push(Layout.columnHead(null, null));
    MATCH_TICKETS_MACHINE_FIELDS.forEach((headCell) => {
      headers.push(
        Layout.columnHead(headCell.label, headCell.id, headCell.align)
      );
    });

    return headers;
  };

  showPdfErrorMessage = (isFailed) => {
    this.props.resetMatchPointPdfPreviewData();
    this.setState({ pdfLoadSuccess: !isFailed });
  };

  closePdfViewer = () => {
    this.setState({ showPdfViewer: false, pdfData: '' }); // Close the PDF viewer and reset URL
  };

  download = () => {
    const date = new Date();
    const getTodayDate = Utils.formatTodayDate(date);
    const fileName = `${this.props.userInfo.firstname} Match Ticket Report - ${getTodayDate}.pdf`;

    Utils.handlePdfAction(this.state.pdfData, 'download', fileName);
  };

  setZoom(zoom) {
    let newScale = Math.min(Math.max(this.state.scale + zoom, 1), 2);
    this.setState({
      scale: newScale,
    });
  }

  fetchPdf = async () => {
    this.props.getMatchPointPDFPreview(
      {
        sessionId: this.props.selectedSessionId,
        locationId: this.props.userInfo.selectedLocationId,
      },
      this.showPdfErrorMessage
    );
    this.setState({ showPdfViewer: true });
  };

  getTicketsForMachine = (machineId) => {
    return this.props.employeeTickets
      .filter((ticketData) => ticketData.machine === machineId)
      .flatMap((ticketData) => ticketData.tickets);
  };

  handleCheckboxChange = (machineId) => {
    const isSelected = this.state.selectedMachine === machineId;

    // When unchecking, close everything
    if (isSelected) {
      this.setState({
        selectedMachine: null,
        showEmployeeList: false,
        showEditEmployeeTickets: false,
        filteredEmployeeTickets: [],
      });
    } else {
      // When checking a machine, open both lists
      const tickets = this.getTicketsForMachine(machineId);
      this.setState({
        selectedMachine: machineId,
        showEmployeeList: true,
        showEditEmployeeTickets: true,
        filteredEmployeeTickets: tickets,
      });
    }
  };

  tableRow = (matchTickets, index) => {
    const differenceClass =
      matchTickets?.diff < 0 ? 'negative-difference' : 'positive-difference';
    return (
      <React.Fragment>
        <TableCell>
          <div
            className="rowSpecSuppliers"
            style={{
              marginRight: '0px',
              marginLeft: '0px',
            }}
          >
            {/*{!this.state.isMobile &&*/}
            <Checkbox
              checked={this.state.selectedMachine === matchTickets.machine}
              onChange={() => this.handleCheckboxChange(matchTickets.machine)}
            />

            {/*}*/}
          </div>
        </TableCell>

        <TableCell className="table-cell-left">
          {matchTickets?.machine}
        </TableCell>
        <TableCell className="table-cell-left">
          {Utils.formatDateTime(matchTickets?.previousReadingTime)}
        </TableCell>
        <TableCell className="table-cell-left">
          {Utils.formatDateTime(matchTickets?.currentReadingTime)}
        </TableCell>
        <TableCell className="table-cell-left">
          {matchTickets?.readingOut}{' '}
        </TableCell>
        <TableCell className="table-cell-left">
          {matchTickets?.ticketOut}{' '}
        </TableCell>

        <TableCell
          style={{ textAlign: 'right' }}
          className={`${differenceClass}`}
        >
          {matchTickets?.diff}
        </TableCell>
      </React.Fragment>
    );
  };

  searchStrings = (employee) => {
    return [employee.employee];
  };

  render() {
    const { showPdfViewer, pdfData } = this.state;

    const totalReadingOut = this.props.differenceList.reduce(
      (acc, item) => acc + item.readingOut,
      0
    );

    // Calculate Ticket Out Total
    const totalSumTicketOut = this.props.differenceList.reduce(
      (acc, item) => acc + item.ticketOut,
      0
    );

    // Calculate the difference
    const differenceReadings = totalReadingOut - totalSumTicketOut;

    let headerButtons = [];

    if (this.state.showPdfViewer) {
      headerButtons.push(
        {
          icon: <KeyboardBackspaceIcon />,
          handler: () => this.closePdfViewer(),
          title: BACK,
        },
        {
          icon: <GetApp />,
          handler: () => this.download(),
          title: 'Download PDF',
        },
        {
          icon: <PrintIcon />,
          title: 'Print PDF',
          handler: () => {
            if (!this.state.pdfData) return;
            Utils.handlePdfAction(
              this.state.pdfData,
              'print',
              'match-ticket-report-print.pdf'
            );
          },
        },
        {
          icon: <ZoomOutIcon />,
          handler: () => this.setZoom(-0.25),
          title: 'Zoom Out',
          disabled: false,
        },
        {
          divider: (
            <span style={{ padding: '5px', marginTop: '5px' }}>
              {this.state.scale * 100}%
            </span>
          ),
        },
        {
          icon: <ZoomInIcon />,
          handler: () => this.setZoom(0.25),
          title: 'Zoom In',
          disabled: false,
        }
      );
    } else {
      headerButtons.push(
        {
          icon: <KeyboardBackspaceIcon />,
          handler: () =>
            this.props.setCurrentPage(MASTER_READING_PAGES.TABLE, {}),
          title: BACK,
        },
        {
          icon: <VisibilityIcon />,
          handler: () => this.fetchPdf(),
          title: 'View Report',
        }
      );
    }

    return (
      <React.Fragment>
        <CustomToolbar
          title={MATCH_TICKETS}
          createTitle={MATCH_TICKETS}
          backTitle={'Back To Menu'}
          onClick={() => {}}
          headerButtons={headerButtons}
        />

        {showPdfViewer ? (
          <RenderPurchaseOrderPDFPreview
            data={pdfData}
            creating={true}
            handlePdfLoadSuccess={this.props.handlePdfLoadSuccess}
            handlePdfLoadError={this.props.handlePdfLoadError}
            scale={this.state.scale}
          />
        ) : (
          <div className="rowSpecSuppliers">
            <div
              style={{
                width: '100%',
              }}
            >
              <div className="rowSpecSuppliers">
                <div
                  style={{
                    backgroundColor: 'lightpink',
                    color: 'black',
                    padding: '16px',
                    textAlign: 'center',
                    fontWeight: 'bold',
                    marginTop: '16px',
                    width: '50%',
                  }}
                >
                  Reading Out Total: ({this.props.differenceList.length}) -> $
                  {totalReadingOut.toFixed(2)}
                </div>

                <div
                  style={{
                    backgroundColor: 'lightskyblue',
                    color: 'black',
                    padding: '16px',
                    textAlign: 'center',
                    fontWeight: 'bold',
                    marginTop: '16px',
                    width: '50%',
                  }}
                >
                  Ticket Out Total: ({this.props.employeeTickets.length}) -> $
                  {totalSumTicketOut.toFixed(2)}
                </div>
              </div>

              <div className="rowSpecSuppliers">
                <div
                  style={{
                    backgroundColor: 'lightgray',
                    color: 'black',
                    padding: '16px',
                    textAlign: 'center',
                    fontWeight: 'bold',
                    marginTop: '16px',
                    width: '50%',
                  }}
                >
                  Difference Readings($) - Tickets($):
                </div>

                <div
                  style={{
                    backgroundColor:
                      parseFloat(differenceReadings.toFixed(2)) < 0
                        ? 'lightcoral'
                        : 'lightgreen',
                    color: 'black',
                    padding: '16px',
                    textAlign: 'center',
                    fontWeight: 'bold',
                    marginTop: '16px',
                    width: '50%',
                  }}
                >
                  {differenceReadings.toFixed(2)}
                </div>
              </div>

              <TablePage
                tableName="matchTickets"
                tableRows={this.props.differenceList}
                tableColumnHeads={this.getTableHeaders()}
                tableRow={this.tableRow}
                paginationText="Results"
              />
            </div>
          </div>
        )}

        {this.state.showEditEmployeeTickets && (
          <EmployeeTicketsTable
            userInfo={this.props.userInfo}
            showEditEmployeeTickets={this.state.showEditEmployeeTickets}
            filteredEmployeeTickets={this.state.filteredEmployeeTickets}
            onClose={() =>
              this.setState({
                showEditEmployeeTickets: false,
                selectedMachine: null,
              })
            }
          />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  PDFpreviewReady: matchPointPDFpreviewReadySelector(state),
  userInfo: userInfoSelector(state),
});

const actionCreators = {
  getMatchPointPDFPreview,
  resetMatchPointPdfPreviewData,
};

export default withShipment(
  {
    actionCreators,
    mapStateToProps,
  },
  MatchTicketsTable
);
